<template>
  <div>
    <table-controls-vue
      v-if="!loading && items.length"
      :has-sticky="true"
      :no-scroll-direction="true"
      classes="is-marginless-bottom">
      <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-small is-last-fixed-small has-actionsontd">
        <thead class="has-cells-vcentered">
          <tr class="is-size-6">
            <th
              class="is-paddingless has-text-centered"
              style="z-index:2;">
              <columns-toggles
                :entries="columnsList"
                :source="columns"
                @update="updateColumns">
              </columns-toggles>
            </th>
            <th>
              <span>Date</span>
            </th>
            <th>
              <span>Lot</span>
            </th>
            <th>
              <span>Vendeur</span>
            </th>
            <th>
              <span>Contact</span>
            </th>
            <th>
              <span>Organisateur</span>
            </th>
            <th class="has-text-centered"></th>
          </tr>
        </thead>
        <tbody class="has-cells-vcentered">
          <tr
            v-for="(option, i) in items.filter(o => o.status === 'waiting_list' || o.status === 'approved')"
            :key="option.pk"
            class="is-size-6"
            :id="'e' + option.pk">
            <td class="is-paddingless has-text-centered is-vcentered">
              <span
                v-if="option.status !== 'accepted'"
                :data-tooltip="optionStatus[option.status].label"
                class="dot tooltip is-tooltip-right"
                :class="optionStatus[option.status].color"></span>
            </td>
            <td
              @click="goToDay(option.end_date)"
              class="is-cell-hoverable has-cursor-pointer">
              {{ option.end_date | prettyFullDatetime }}
            </td>
            <td>
              {{ option.lot.ref }}
            </td>
            <td class="is-cell-hoverable">
              <router-link :to="{name: 'UserVue', params: {id: option.user.pk}}">
                {{ option.user.last_name }} {{ option.user.first_name }}
              </router-link>
            </td>
            <td class="is-cell-hoverable">
              <router-link :to="{name: 'ContactVue', params: {id: option.contact.pk}}">
                {{ option.contact.last_name }} {{ option.contact.first_name }}
              </router-link>
            </td>
            <td class="is-cell-hoverable">
              <router-link :to="{name: 'UserVue', params: {id: option.user.pk}}">
                {{ option.user.last_name }} {{ option.user.first_name }}
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </table-controls-vue>
    <div v-show="!loading && !items.length">
      <div class="is-padding">
        <h2 class="title is-3 has-text-weight-bold">
          Aucune option à afficher
        </h2>
        <a
          class="has-text-primary"
          @click="resetFilters"
          v-if="hasFilter"><span class="icon"><i class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
      </div>
    </div>
    <pagination
      :loading="loading"
      :current-page="currentPage"
      :total-page="totalPage"
      @changePage="loadItems($event)"></pagination>
  </div>
</template>

<script>
import { ColumnConf, Quickview, DefaultValues } from '@/mixins'
import moment from 'moment'

export default {
  name: 'OptionsCalendarList',
  filters: {
    optionStatus (status) {
      let statusLabel = {
        accepted: 'Accepté',
        waitingList: 'En liste d\'attente',
        expired: 'Expiré',
        canceled: 'Annulé'
      }
      return statusLabel[status]
    }
  },
  mixins: [ColumnConf, Quickview, DefaultValues],
  props: {
    items: Array,
    hasFilter: Boolean,
    currentPage: Number,
    totalPage: Number
  },
  data () {
    return {
    }
  },
  computed: {
    columnsShow () {
      let columns = {
        guests: { label: 'Invité(s)', mobile: true },
        author: { label: 'Organisateur', mobile: true }
      }
      return columns
    }
  },
  methods: {
    goToDay (date) {
      let day = moment(date).format('DD')
      let month = moment(date).format('MM')
      let year = moment(date).format('YYYY')
      this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'options' } })
    },
    resetFilters () {
      this.$emit('resetFilters', event)
    },
    loadItems (event) {
      this.$emit('loadItems', event)
    }
  }
}
</script>
